import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

@Injectable({ providedIn: 'root' })
export class ActiveState implements OnDestroy {
    public name: string;

    private unsubscriber = new Subject<void>();

    constructor(router: Router, route: ActivatedRoute) {
        router.events.pipe(takeUntil(this.unsubscriber)).subscribe((event) => {
            if (event instanceof NavigationEnd) {
                // Traverse the active route tree
                let snapshot = route.snapshot;
                let activated = route.firstChild;
                if (activated != null) {
                    while (activated != null) {
                        snapshot = activated.snapshot;
                        activated = activated.firstChild;
                    }
                }

                // Try finding the 'stateName' from the data
                this.name = snapshot.data['stateName'] || 'unnamed';
            }
        });
    }

    is(name: string): boolean {
        return this.name === name;
    }

    ngOnDestroy() {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
